import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import Dd_Sel from "../../../../lib/ui/dd_sel";
import * as net from "../../../../lib/net";

class Petty_Rad extends React.Component {
  constructor(props, context) {
    super(props);

    this.fkn_close = null;
    this.state = {};
    this.state.ynq = [];

    this.state.paa = [];
    this.state.aa = [];

    this.state.boknr = "";
    this.state.rvo = {};
    if(props.wnds) {
        this.fkn_close = props.wnds.fkn_close;
        this.state.boknr = props.wnds.boknr;
        this.state.gso = props.wnds.gso;
        this.state.row = props.wnds.row;
    }

    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.dts = dts;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }


    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close() {
      if(this.fkn_close) this.fkn_close(this.props.ctx);
      else this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  corr_row() {
    var self = this;

    var tro = this.state.row.etr01;

    var prm = {};
    prm.req = "pms.sell.corr_tr";
    prm.boknr = this.state.boknr;
    prm.gsb00 = this.state.gso;
    prm.etr01 = tro;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rco));

      if(self.fkn_close) self.fkn_close(self.props.ctx);
      else self.props.ctx.setState({ wnds: {} });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  split_to_gst() {
    var self = this;
  }
  move_row() {
    var self = this;
  }
  split_row() {
    var self = this;
  }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="m2_backdrop" /> : null }
        <div className="m2_dlg mx_50h flex-col" style={ this.dlg_style() }>
        <div className="flex-row " style={{padding:"0px",height:"50px",lineHeight:"50px", background: "#1a456b", color: "#fff"}}>
                <div className="flex-row flex" style={{padding:"0px 5px", fontSize: "22px"}}>
                    <div>PETTYCASH RAD { this.state.rumsnr }</div>
                </div>
            <div className="wnd-close-btn" onClick={() => this.wnd_close() }>X</div>
        </div>
        <div className="mx_content flex">

        <div className="web-col flex-center flex">
            <div className="wnd-btn w250" onClick={() => this.corr_row() } >
                <div>KORRIGERA RAD</div>
                <div></div>
            </div>
        </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <div className="flex-row"></div>
            <button className="btn btn-hw-red w250 ripple" onClick={() => this.wnd_close() } >
                AVBRYT
            </button>
            <div className="flex-row"></div>
        </div>
      </div>
    </div>
	;
	return html;
  };
}

export default Petty_Rad;